__turbopack_context__.v({
  "accordionSlideOverwrite": "animatedBackground-module-scss-module__1aBGhG__accordionSlideOverwrite",
  "animatedSvg": "animatedBackground-module-scss-module__1aBGhG__animatedSvg",
  "fadeIn": "animatedBackground-module-scss-module__1aBGhG__fadeIn",
  "fadeOut": "animatedBackground-module-scss-module__1aBGhG__fadeOut",
  "scaleIn": "animatedBackground-module-scss-module__1aBGhG__scaleIn",
  "scaleOut": "animatedBackground-module-scss-module__1aBGhG__scaleOut",
  "zoomIn": "animatedBackground-module-scss-module__1aBGhG__zoomIn",
  "zoomOut": "animatedBackground-module-scss-module__1aBGhG__zoomOut",
});
